import { render, staticRenderFns } from "./FormViewerMultiUpload.vue?vue&type=template&id=b582f13a&scoped=true"
import script from "./FormViewerMultiUpload.vue?vue&type=script&lang=js"
export * from "./FormViewerMultiUpload.vue?vue&type=script&lang=js"
import style0 from "./FormViewerMultiUpload.vue?vue&type=style&index=0&id=b582f13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b582f13a",
  null
  
)

export default component.exports